module.exports = __webpack_public_path__ + "img/secure-data-animate.ca8161e7.svg";